// extracted by mini-css-extract-plugin
export default {"cls1":"hpt31ycwfm_TM1Ae21eq","cls2":"WCVfjj5_SrCJkU5wgGMv hpt31ycwfm_TM1Ae21eq"};